import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import {
  FormCrumbs,
} from "../../utils/BreadcrumbData";

export const Forms = () => {
  return <Breadcrumb items={FormCrumbs} />;
};
